import { useTranslator } from '@translator-app/react';
import { IRoute, SideBar } from '~/components/sidebar';
import React from 'react';

import { AuthRolesEnum } from '../../enums';

export const AdminPanelSidebar: React.FC = () => {
  let { language } = useTranslator();

  let routes = React.useMemo(() => {
    let value: Array<IRoute> = [
      {
        translationKey: 'Organisations',
        role: AuthRolesEnum.Member,
        href: '/',
      },
      {
        translationKey: 'Create Organisation',
        role: AuthRolesEnum.Dealer,
        href: '/admin/organisations/create',
      },
      {
        translationKey: 'service-locations',
        role: AuthRolesEnum.Dealer,
        href: '/admin/gateways',
      },
      {
        translationKey: 'Resellers',
        role: AuthRolesEnum.Reseller,
        href: '/admin/resellers',
      },
      {
        translationKey: 'Dealers',
        role: AuthRolesEnum.Dealer,
        href: '/admin/dealers',
      },
      {
        translationKey: 'Announcements',
        role: AuthRolesEnum.SuperUser,
        href: '/admin/announcement',
      },
      {
        translationKey: 'Announcements',
        role: AuthRolesEnum.Member,
        href: '/announcements',
      },
      {
        translationKey: 'Documentation',
        role: AuthRolesEnum.Member,
        href: `https://www.docs.viresmo.com/${language}`,
      },
      {
        translationKey: 'Firmware',
        role: AuthRolesEnum.SuperUser,
        href: '/admin/firmware',
      },
      {
        translationKey: 'Billing Logs',
        role: AuthRolesEnum.SuperUser,
        href: '/admin/billing-logs',
      },
      {
        translationKey: 'Telemetry',
        role: AuthRolesEnum.SuperUser,
        href: '/admin/telemetry',
      },
      {
        translationKey: 'Database',
        role: AuthRolesEnum.SuperUser,
        href: '/admin/database',
      },
      {
        translationKey: 'Email previews',
        role: AuthRolesEnum.SuperUser,
        href: '/admin/email-previews',
      },
      {
        translationKey: 'Payments',
        role: AuthRolesEnum.SuperUser,
        href: '/admin/payments',
      },
    ];

    return value;
  }, [language]);

  return <SideBar routes={routes} />;
};
